// ============================================================
// data/audiences.ts — 4 públicos-alvo do Lume
// ============================================================
// Alimentado por docs/ux/personas.md (9 personas) do programa.
// ============================================================

export interface Audience {
  id: string;
  iconKey: 'autist' | 'caregiver' | 'physician' | 'multidisc';
  title: string;
  subtitle: string;
  highlights: ReadonlyArray<string>;
  cta?: { label: string; href: string };
}

export const audiences: ReadonlyArray<Audience> = [
  {
    id: 'autist',
    iconKey: 'autist',
    title: 'Pessoa autista',
    subtitle: 'Níveis 1, 2 e 3 de suporte (DSM-5-TR / CID-11 6A02.0–5)',
    highlights: [
      'Interface adaptada por nível de suporte',
      'Baixa densidade visual e linguagem literal',
      'CAA com pictogramas ARASAAC e voz',
      'Modo Calma e Modo Distração para autorregulação',
      'Sem badges, sem leaderboards, sem gamificação infantilizante',
    ],
  },
  {
    id: 'caregiver',
    iconKey: 'caregiver',
    title: 'Cuidador',
    subtitle: 'Familiar, profissional ou cuidador da rede de apoio',
    highlights: [
      'Revisão diária do paciente em poucos segundos',
      'Registro ABC e administração de medicação',
      'Alertas críticos e Modo Crise com SAMU 192',
      'Comunicação direta com a equipe clínica',
    ],
  },
  {
    id: 'physician',
    iconKey: 'physician',
    title: 'Profissional / médico',
    subtitle: 'Médico assistente, neurologista, psiquiatra',
    highlights: [
      'Painel multipaciente com priorização inteligente',
      'Prontuário vivo com indicador de fonte de dados',
      'IA clínica sumariza, sempre flagada “Hipótese — não diagnóstico”',
      'Teleconsulta WebRTC P2P integrada ao prontuário',
      'Prescrição com checagem de interação medicamentosa',
    ],
  },
  {
    id: 'multidisc',
    iconKey: 'multidisc',
    title: 'Equipe multidisciplinar',
    subtitle: 'Fonoaudiologia, terapia ocupacional, psicologia, assistência social',
    highlights: [
      'Plano terapêutico versionado e compartilhado',
      'Linha do tempo clínica integrada',
      'Notas de evolução estruturadas por papel',
      'Acompanhamento longitudinal com instrumentos validados',
    ],
  },
];
